import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerEdit, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { LabelForm } from '../componentes_generales/componentes_formulario/labels/';
import { InputText } from '../componentes_generales/componentes_formulario/inputs/inputtext';
import styled from 'styled-components';
import global_axios  from '../../funciones_globales/interaccionapi';
import { cargarCatalogosAsync, cargarCatalogos_Otros } from '../../funciones_globales/catalogos';
import ReactSelect from '../componentes_generales/componentes_formulario/selects/react-select';
import moment from 'moment';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import ReactSelectAsync from '../componentes_generales/componentes_formulario/selects/react-select-async';
import { cargarCatalogosGenericoAsyncInvertido } from '../../funciones_globales/catalogos';
import '../componentes_generales/componentes_formulario/contenedores/flexbox.css'
import { getItemDatosSesion } from '../../funciones_globales/manejosesion';
import { validarPermisoAcceso } from '../../funciones_globales/utils';
import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';
import { getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';

const Button = styled.button`
    .medida-button-busq-Select{
        padding: 4px 6px;
    }
    height: 27px;
    font-size: 11px;
`;
    

class FormBanco13 extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            //Global
            operacion: 'G', //G GUARDAR - M Modificar
            permiso: null, //G SOLO GUARDAR => M Guardar & Modificar
            planVigente: null,
            fechaProceso: null,

            //REPOSITORIOS
            repCuentas: [],

            //CATALOGOS
            catCuentas: [],
            catCuentas_sel: null,
            tipoCuentaBancaria: [{value: 'CC', label: 'CORRIENTE (CC)'},{value: 'AH', label: 'AHORROS (AH)'}],
            tipoCuentaBancaria_sel: null,
            estado: [{value: 'A', label: 'ACTIVO (A)'},{value: 'I', label: 'INACTIVO (I)'}],
            estado_sel: 'A',

            //Inputs
            nombreCuentaBan: '',
            numCuentaBancaria: '',
            secuenciaBancaria: '',
            reporte: '',
            papeleta: '',

            //Async
            cuenta_sel: null,
            banco_sel: null,

            //CTA ANTERIOR
            cuentaAnterior: null
        };

        this.actualizarCamposCheque = this.actualizarCamposCheque.bind(this);
        this.getOptions_CtaContable = this.getOptions_CtaContable.bind(this);
        this.limpiarPantalla = this.limpiarPantalla.bind(this);
        this.guardarCuentaBancaria = this.guardarCuentaBancaria.bind(this);
        this.getCuenta = this.getCuenta.bind(this);
    }

    //Opcion a consultar , Nombre del state a guardar
    cargarCatalogosOtrosCatchResult(tipo, name) {
        return new Promise((resolve, reject) => {
            global_axios.get('/catalogos?tipo=otros&opcion=' + tipo)
            .then((response)=>{
                console.log('DATA: ', response)
                this.setState({[name]: response.data});
                resolve(response.data.map(item => ({value: item.Codigo.toString().toUpperCase(), label: `${item.Descripcion.toString().toUpperCase().trim()}-${item.Numero} (${item.Codigo.toString().toUpperCase()})` })));
            })
            .catch((err)=>{
                reject('Error al cargar datos de catálogos desde API: ' + err);
            });
        });
    }

    cargarObjetos(ruta){
        return new Promise((resolve, reject) => {
            global_axios.get(ruta)
            .then((response)=>{
                resolve(response.data)
            })
            .catch((err)=>{

                reject('No existe movimiento a presentar...');
            });
        });
    }

    getOptions_CtaContable(input, callback){
        /* /cuentas?cadena_busq=52.02.20.12&plan=001 FILTRO POR PLAN DE CUENTAS*/ 

        if (input.toString().length >= 2 ){            
            let cadena_busq = '?cadena_busq='+ input + '&plan=' + this.state.planVigente;
            cargarCatalogosGenericoAsyncInvertido('/cuentas', cadena_busq, callback)
        }
    }

    getOptions_Banco(input, callback){
        if (input.toString().length >= 2 ){
            cargarCatalogosAsync('BANCO', input, callback)
        }
    }

    //OverControls
    actualizarCamposCheque(event){
        const target = event.target;       
        const name = target.name;    
        const value = target.type === 'checkbox'? target.checked : target.value;
        this.setState({
          [name]: value
        });
    }

    componentDidMount(){ 
        Promise.all([
            cargarCatalogos_Otros('GEN-PLANVIG'), 
            this.cargarCatalogosOtrosCatchResult('BAN-CTASDEPMANT', 'repCuentas'),
            this.props.generar_LogAuditoriaIngresoForm('0713'), ])
        .then(([ r_planVigente, r_ctasBancarias ])=>{
            console.log('FORMATED C_UENTAS: ', r_ctasBancarias)
            //FECHA DE PROCESO POR MODULO
            let fechaProceso = getFechaProcesoPorModulo('07');
            
            this.setState({ planVigente: r_planVigente[0].value, 
            catCuentas: r_ctasBancarias, permiso: this.props.permiso, 
            fechaProceso: moment(fechaProceso, 'DD/MM/YYYY')})
        })
        .catch(()=>{
            alert('Parametros de sistema no han sido cargados.')
        })
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0713');
    }

    getCuenta(){
        var errors = "";
        var proceder = true;

        if(this.state.catCuentas_sel){
            errors += '- Seleccione una cuenta bancaria.'
        }

        //Proceso de grabacion
        if(proceder === true){            
            let config_request = {
                method: 'GET',
                url: '/cuentasbancarias/'+this.state.catCuentas_sel
            }  
            global_axios(config_request)
            .then((response)=> {  
                if(response){
                    let data = response.data;
                    console.log('RESPUESTA: ', response.data)

                    let banco = {};
                    if(data.bancoDet){
                        banco.value = data.bancoDet.Codigo;
                        banco.label = `${data.bancoDet.Descripcion.toString().toUpperCase()} (${banco.value})`;
                    }

                    let cuenta = {};
                    if(data.cuentaDet){
                        if(data.cuentaDet.PlanCuenta === this.state.planVigente){
                            cuenta.value = data.cuentaDet.Codigo;
                            cuenta.label = `${data.cuentaDet.Descripcion.toString().toUpperCase()} (${cuenta.value})`;
                        }
                    }
                    
                    this.setState({operacion: 'M', 
                        cuenta_sel: data.cuentaDet?(Object.keys(data.cuentaDet).length>0?cuenta:null):null, 
                        banco_sel: data.bancoDet?(Object.keys(data.bancoDet).length>0?banco:null):null,
                        tipoCuentaBancaria_sel: data.TipoCuenta?data.TipoCuenta:null,
                        nombreCuentaBan: data.Nombre?data.Nombre.toString().toUpperCase().trim():'',
                        numCuentaBancaria: data.Numero?data.Numero.toString().trim():'',
                        secuenciaBancaria: data.SecuenciaCheque?parseInt(data.SecuenciaCheque, 10):'',
                        reporte: data.Rpt?data.Rpt.toString().trim():'',
                        papeleta: data.Papeleta?parseInt(data.Papeleta,10):'',
                        estado_sel: data.Status?data.Status.toString().trim():null,
                        cuentaAnterior: data.ConCuenta?data.ConCuenta:null,
                        usuarioOriginal: data.Usuario?data.Usuario:null
                    })                    
                } 
            })
            .catch((error)=>{                           
                alert(error.response?error.response.data.msg:error.message);
            });
        }else{
            alert(errors)
        }
    }

    guardarCuentaBancaria(){
        var errors = "";
        var proceder = true;
        var data = {};

        if(!this.state.banco_sel){
            errors+='- Seleccione un banco.\n'
            proceder = false;
        }

        if(!this.state.tipoCuentaBancaria_sel){
            errors+='- Seleccione un tipo de cuenta.\n'
            proceder = false;
        }

        if(!this.state.nombreCuentaBan){
            errors+='- Ingrese una descripción para la cuenta.\n'
            proceder = false;
        }

        if(!this.state.numCuentaBancaria){
            errors+='- Ingrese un número de cta. bancaria.\n'
            proceder = false;
        }

        if(!this.state.cuenta_sel){
            errors+='- Ingrese una cta. contable.\n'
            proceder = false;
        }

        if(!this.state.estado){
            errors+='- Seleccione un estado.\n'
            proceder = false;
        }

        //Validacion de permisos
        let operacion = validarPermisoAcceso(this.state.operacion, this.state.permiso)
        if(operacion.esValido===false){
            proceder = false;
            errors = errors+operacion.msg
        }

        if(proceder === true){

            let fechaProceso = getFechaProcesoPorModulo('07');

            data.Localidad = '01';
            data.Cuenta = this.state.operacion==='M'?this.state.catCuentas_sel:'';
            data.Nombre = this.state.nombreCuentaBan.toString().toUpperCase();
            data.Numero = this.state.numCuentaBancaria;
            data.ConCuenta = this.state.cuenta_sel?this.state.cuenta_sel.value:null;
            data.Moneda = JSON.parse(getItemDatosSesion('moneda')).Moneda;;
            data.Status = this.state.estado_sel;
            data.Banco = this.state.banco_sel.value;
            data.SecuenciaCheque = this.state.secuenciaBancaria;
            data.NombreRpt = this.state.reporte;
            data.CuentaAnterior = this.state.cuentaAnterior;
            data.TipoCuenta = this.state.tipoCuentaBancaria_sel;
            data.Papeleta = parseInt(this.state.papeleta,10);
            data.FechaProceso = fechaProceso;
            data.Usuario = this.props.usuario;
            data.IdRegAudit = this.props.IdRegAudit;
            
            if(this.state.operacion === 'M'){
                data.UsuarioOriginal = this.state.usuarioOriginal;
            }
            
            console.log('DATA: ', data)

            global_axios({
                method: this.state.operacion==='G'?'POST':'PATCH',
                url: this.state.operacion==='G'?'/cuentasbancarias':'/cuentasbancarias/'+this.state.catCuentas_sel,
                data
            })
            .then((response)=>{
                if(response){
                    alert(response.data.msg)
                    this.limpiarPantalla('A');

                    this.cargarCatalogosOtrosCatchResult('BAN-CTASDEPMANT', 'repCuentas').then((cat)=>{
                        this.setState({catCuentas: cat, operacion: 'G'})
                    })
                    .catch((error)=>{
                        alert(error.response?error.response.data.msg:error.message);      
                        this.cargarCatalogosOtrosCatchResult('BAN-CTASDEPMANT', 'repCuentas').then((cat)=>{
                            this.setState({catCuentas: cat, operacion: 'G'})
                        })
                    })
                }
            })
            .catch((error)=>{                
                alert(error.response?error.response.data.msg:error.message);      
                this.cargarCatalogosOtrosCatchResult('BAN-CTASDEPMANT', 'repCuentas').then((cat)=>{
                    this.setState({catCuentas: cat, operacion: 'G'})
                })
            });
        }else{
            alert(errors)
        }
    }

    limpiarPantalla(param){

        if(param === 'A'){
            this.setState({cuenta_sel: null})
        }

        this.setState({
            nombreCuentaBan: '',
            numCuentaBancaria: '',
            secuenciaBancaria: '',
            reporte: '',
            papeleta: '',
            banco_sel: null,
            estado_sel: 'A',
            tipoCuentaBancaria_sel: null,
            catCuentas_sel: null,
            cuentaAnterior: null,
            operacion: 'G'
        })
    }

    render(){
        return(
            <ContenedorForm porc_ancho={70}>
             <HeaderForm>
                <TituloForm>Mantenimiento de Ctas. Bancarias</TituloForm>
            </HeaderForm>
                <CuerpoForm>
                    <ContainerEdit alto={50}>
                        <Row>
                            <ContainerCol className='col-sm-8'>
                                <Row>
                                    <ContainerCol className='col-sm-2'>
                                        <LabelForm>Cta. Bancaria:</LabelForm>                                
                                    </ContainerCol>
                                    <ContainerCol className='col-sm-10'>
                                        <div className='input-group'>
                                            <ReactSelect options={ this.state.catCuentas } value={this.state.catCuentas_sel} func_onChange={(value)=>{this.setState({catCuentas_sel: value!==null?value.value:null})}}/>
                                            <span className='input-group-addon addon-busq-Select'>
                                                <Button type="button" className='btn btn-default medida-button-busq-Select' onClick={this.getCuenta}><i className='fa fa-check-circle-o fa-lg'/> Sel.</Button>
                                            </span>
                                        </div>
                                    </ContainerCol>
                                </Row>
                            </ContainerCol>                            
                        </Row>
                    </ContainerEdit>
                    <Row>
                        <ContainerCol className='col-sm-3'>
                            <LabelForm>Banco:</LabelForm>      
                            <ReactSelectAsync value={this.state.banco_sel} func_loadOptions={this.getOptions_Banco}
                            func_onChange={(value)=>{if(Array.isArray(value)){value=null};this.setState({banco_sel: value?value:null});}}/>  
                        </ContainerCol>                        

                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Tipo Cuenta:</LabelForm>      
                            <ReactSelect options={ this.state.tipoCuentaBancaria } value={this.state.tipoCuentaBancaria_sel} func_onChange={(value)=>{this.setState({tipoCuentaBancaria_sel: value!==null?value.value:null})}}/>                             
                        </ContainerCol>

                        <ContainerCol className='col-sm-5'>
                            <LabelForm>Descripción Cuenta:</LabelForm>      
                            <InputText mayusculas={true} margen_abajo='4' autoComplete='off' name="nombreCuentaBan"  value={this.state.nombreCuentaBan} onChange={this.actualizarCamposCheque} maxLength={40}/>
                        </ContainerCol>

                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Número de Cta.:</LabelForm>      
                            <InputText margen_abajo='4' autoComplete='off' name="numCuentaBancaria"  value={this.state.numCuentaBancaria} onChange={this.actualizarCamposCheque} maxLength={15}/>
                        </ContainerCol>
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-5'>
                            <LabelForm>Cta. Contable:</LabelForm>      
                            <ReactSelectAsync value={this.state.cuenta_sel} func_loadOptions={this.getOptions_CtaContable}
                            func_onChange={(value)=>{if(Array.isArray(value)){value=null};this.setState({cuenta_sel: value?value:null});}}/>                              
                        </ContainerCol>

                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Secuencia de Ch.:</LabelForm>      
                            <InputText margen_abajo='4' autoComplete='off' name="secuenciaBancaria"  value={this.state.secuenciaBancaria} onChange={this.actualizarCamposCheque} maxLength={7}/>
                        </ContainerCol>                        

                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Nombre de Reporte:</LabelForm>      
                            <InputText margen_abajo='4' autoComplete='off' name="reporte"  value={this.state.reporte} onChange={this.actualizarCamposCheque} maxLength={20}/>
                        </ContainerCol>

                        <ContainerCol className='col-sm-1'>
                            <LabelForm>Cod. P:</LabelForm>      
                            <InputText margen_abajo='4' autoComplete='off' name="papeleta"  value={this.state.papeleta} onChange={this.actualizarCamposCheque} maxLength={2}/>
                        </ContainerCol>

                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Estado:</LabelForm>      
                            <ReactSelect options={ this.state.estado } value={this.state.estado_sel} func_onChange={(value)=>{this.setState({estado_sel: value!==null?value.value:null})}}/>                             
                        </ContainerCol>                  
                    </Row>
                    <Row margen_arriba={10}>
                        <div className='col-sm-12'>
                            <div className='btn-group pull-right'>
                                <button type='button' className='btn btn-primary btn-sm' onClick={this.guardarCuentaBancaria}><i className='fa fa-floppy-o fa-lg'/> Guardar</button>
                                <button type='button' className='btn btn-sm' onClick={()=>{this.limpiarPantalla('A')}}><i className='fa fa-trash-o fa-lg'/> Limpiar</button>                 
                            </div>
                        </div>
                    </Row>
                </CuerpoForm>
            </ContenedorForm>
        )
    }
}

const mapStateToProps = ((state) => {
    return {puntoFacturacionSel: state.ventas.ptoFacturacionSel, 
            permiso: state.sesion.valoresSesionForm.Permiso,
            usuario: state.sesion.valoresSesionForm.Usuario,
            IdRegAudit: state.sesion.valoresSesionForm.IdRegAudit,
            departamento : state.sesion.valoresSesionForm.Departamento,
        }
});
  
const mapDispatchToProps = ((dispatch) => {  
return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm,
                            cambiar_VisualizacionLoading }, dispatch)
});
  
export default connect (mapStateToProps, mapDispatchToProps)(FormBanco13);